import { HomeworkSubmittedStudentTable } from './HomeworkSubmittedStudentTable';
export default HomeworkSubmittedStudentTable;
